


import { SubDomain } from "../../SubDomain.js";
import Question from "./Question.js";

export default class QuestionsDomain extends SubDomain {
  
  constructor(domain, storage) {
    super(domain, Question.MODEL_NAME);
    this.storage = storage;
  }

  list() {
    return this.storage.list;
  }
  
  findById(objId) {
    var objects = this.list();
    for (var i = 0; i < objects.length; i++) {
      var item = objects[i];
      if (super.toId(item) == objId) {
        return new Question(this.domain, item);
      }
    }

    return new Question(this.domain);
  }
}